/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { promotionText } from '../../../core/Constants';
import { getImageURL, getHostCURL } from '../../../common/utils/CardUtils';
import { OffersCardTile } from '../OffersNotificationSection/Notifications/OffersCardTile';

const PreferredPricingPromo = () => {
  return (
    <a
      className="sui-text-sm sui-leading-8 sui-float-left sui-border-1 sui-w-full sui-border-primary"
      data-testid=""
      href={getHostCURL('/myaccount/proXtraPricing')}
      rel=" noreferrer"
    >
      <div className="col__10-12">
        <div>{promotionText.PreferredPricingPromo}</div>
        <div className="sui-underline">
          <span>Learn More</span>
        </div>
      </div>
      <div className="col__2-12 sui-relative sui-top-1 sui-flex sui-justify-end sui-items-center">
        <img
          width="38"
          height="34"
          src={getImageURL('ProTiers/cardIcon-PreferredPricing.svg')}
          alt="PP_RGB_Orange-Black"
          className="sui-inline-block"
        />
      </div>
    </a>
  );
};

const VolumePricingPromo = () => {
  return (
    <OffersCardTile
      imageURL="ProTiers/cardIcon-VPP-black.svg"
      altText="volume-pricing"
      refLink="/myaccount/dashboard"
      linkText="Learn More"
    >
      <Typography variant="body-base" weight="regular" height="normal">
        {promotionText.VolumePricingPromo}
      </Typography>
    </OffersCardTile>
  );
};

const PlccAcquisitionPromo = ({ activePxccFactor }) => {
  const spendMultiplier = activePxccFactor || 4;
  return (
    <a
      className="sui-text-sm sui-leading-8 sui-float-left sui-border-1 sui-w-full sui-border-primary"
      data-testid=""
      href={getHostCURL('/c/credit-center#RevolvingChargeCard')}
      rel=" noreferrer"
    >
      <div className="col__9-12">
        <div>{promotionText.PlccAcquisitionPromo}</div>
        <div className="sui-underline">
          <span>Earn Perks {spendMultiplier}X Faster</span>
        </div>
      </div>
      <div className="col__3-12 sui-flex sui-justify-end sui-items-center">
        <img className="cardImage" src={getImageURL('plcc-angled.svg')} width="auto" height="auto" alt="plcc-angled" />
      </div>
    </a>
  );
};

const TextToConfirmPromo = () => {
  return (
    <a
      className="sui-text-sm sui-leading-8 sui-float-left sui-border-1 sui-w-full sui-border-primary"
      data-testid=""
      href={getHostCURL('/myaccount/payments')}
      rel=" noreferrer"
    >
      <div className="col__10-12">
        <div>{promotionText.TextToConfirmPromo}</div>
        <div className="sui-underline">
          <span>Learn About Text2Confirm</span>
        </div>
      </div>
      <div className="col__2-12 sui-relative sui-top-1 sui-flex sui-justify-end sui-items-center">
        <img
          width="35px"
          height="35px"
          src={getImageURL('PrgDetails/icons-Text2Confirm@2x.png')}
          alt="text-confirm"
          className="sui-inline-block"
        />
      </div>
    </a>
  );
};

const PaintProductsPromo = () => {
  const paintsProductClasses = 'sui-text-sm sui-leading-8 sui-float-left sui-border-1 sui-w-full sui-border-primary';
  return (
    <a className={paintsProductClasses} data-testid="" href="" rel=" noreferrer">
      <div className="col__10-12">
        <div>{promotionText.PaintProductsPromo}</div>
        <div className="sui-underline">
          <span>View Details</span>
        </div>
      </div>
      <div className="col__2-12 sui-relative sui-top-1 sui-flex sui-justify-end sui-items-center">
        <img
          width="28.08px"
          height="36px"
          src={getImageURL('PrgDetails/Group 26@2x.png')}
          alt="icon-PaintRewards"
          className="sui-inline-block"
        />
      </div>
    </a>
  );
};

export const PLCCPurchaser = () => {
  return (
    <OffersCardTile
      imageURL="WelcomeCard/active_perks_PLCC.svg"
      altText="Credit Card Promo"
      refLink="/b2b/account/view/thdcreditcard"
      linkText="Learn More"
    >
      <Typography variant="body-base" weight="regular" height="normal">
        New Pro Xtra Credit Card
      </Typography>
    </OffersCardTile>
  );
};

const ProXtraGeneralKnowledgePromo = () => {
  return (
    <a
      className="sui-text-sm sui-leading-8 sui-float-left sui-border-1 sui-w-full sui-border-primary"
      data-testid=""
      href={getHostCURL('/myaccount/proXtraRewards')}
      rel=" noreferrer"
    >
      <div className="col__10-12">
        <div>{promotionText.ProXtraGeneralKnowledgePromo}</div>
        <div className="sui-underline">
          <span>Learn More</span>
        </div>
      </div>
      <div className="col__2-12 sui-relative sui-top-1 sui-flex sui-justify-end sui-items-center">
        <img
          width="36px"
          height="37px"
          src={getImageURL('Pro-Xtra_Perk_Icon-whiteFill.svg')}
          alt="pro-extra-perk"
          className="sui-inline-block"
        />
      </div>
    </a>
  );
};

const ManageProjectMore = () => {
  const manageProjectClasses = 'sui-text-sm sui-leading-8 sui-float-left sui-border-1 sui-w-full sui-border-primary';
  return (
    <a className={manageProjectClasses} data-testid="" href="" rel=" noreferrer">
      <div className="col__10-12">
        <div>{promotionText.ManageProjectMore}</div>
        <div className="sui-underline">
          <span>Learn More</span>
        </div>
      </div>
      <div className="col__2-12 sui-flex sui-justify-end sui-items-center">
        <img
          width="54px"
          height="39px"
          src={getImageURL('plcc-angled.svg')}
          alt="plcc-angled"
          className="sui-inline-block"
        />
      </div>
    </a>
  );
};

const RegisteredTender = ({ isMobile }) => {
  return (
    <OffersCardTile
      imageURL="RegisteredTender.svg"
      imageClass="registered-tender"
      altText="registered-tender"
      refLink="/myaccount/payments"
      linkText="Get Easy Purchase Tracking"
    >
      <Typography variant="body-base" weight="regular" height="normal">
        {promotionText.RegisteredTender}
      </Typography>
    </OffersCardTile>
  );
};

const AppAwarenessPromo = () => {
  return (
    <OffersCardTile
      imageURL="appAwarenessIcon.svg"
      altText="app-awareness"
      refLink="/c/mobile-app"
      linkText="Explore the App"
    >
      <Typography variant="body-base" weight="regular" height="normal">
        {promotionText.AppAwarenessPromo}
      </Typography>
    </OffersCardTile>
  );
};

const ProOnlineExperiencePromo = () => {
  return (
    <OffersCardTile
      imageURL="WelcomeCard/active_BusinessTools.svg"
      altText="pro-online-experience"
      refLink="/c/pro-resources"
      linkText="Learn More"
    >
      <Typography variant="body-base" weight="regular" height="normal">
        {promotionText.ProOnlineExperiencePromo}
      </Typography>
    </OffersCardTile>
  );
};

const RenderPromotionTiles = ({ tiles }) => {
  return <div> {tiles}</div>;
};

export const showingTilePromotions = ({ isAdmin, userData }) => {
  const { preferredPricingTierZero } = userData?.customerInfo || {};
  const { pxccUserCategory } = userData?.perkSummary || {};
  const showingTile = {
    RegisteredTender: true,
    PreferredPricingPromo: preferredPricingTierZero,
    PLCCPurchaser: false,
    PlccAcquisitionPromo: isAdmin && pxccUserCategory === 'Targeted',
    AppAwarenessPromo: true,
    ProOnlineExperiencePromo: true,
    VolumePricingPromo: true,
    TextToConfirmPromo: isAdmin,
    ProXtraGeneralKnowledgePromo: isAdmin,
    PaintProductsPromo: false,
    ManageProjectMore: false,
  };
  return showingTile;
};

export const prioritizedListPromotions = ({ showingTile, userData, isMobile }) => {
  const { activePxccFactor } = userData?.perkSummary || {};
  const prioritizedList = [
    showingTile.RegisteredTender && <RegisteredTender isMobile={isMobile} />,
    showingTile.PreferredPricingPromo && <PreferredPricingPromo />,
    showingTile.PLCCPurchaser && <PLCCPurchaser />,
    showingTile.PlccAcquisitionPromo && (
      <PlccAcquisitionPromo activePxccFactor={activePxccFactor} />
    ),
    showingTile.AppAwarenessPromo && <AppAwarenessPromo />,
    showingTile.ProOnlineExperiencePromo && <ProOnlineExperiencePromo />,
    showingTile.VolumePricingPromo && <VolumePricingPromo />,
    showingTile.TextToConfirmPromo && <TextToConfirmPromo />,
    showingTile.ProXtraGeneralKnowledgePromo && <ProXtraGeneralKnowledgePromo />,
    showingTile.PaintProductsPromo && <PaintProductsPromo />,
    showingTile.ManageProjectMore && <ManageProjectMore />,
  ];
  return prioritizedList;
};

const OffersPromotionSection = ({ tiles }) => {
  const DisplayTiles = () => {
    if (!Array.isArray(tiles)) {
      return tiles;
    }
    return tiles.map((tile, index) => {
      // If tile already has a key, use it; otherwise use index as fallback
      if (React.isValidElement(tile) && tile.key) {
        return tile;
      }
      return React.isValidElement(tile)
        ? React.cloneElement(tile, { key: tile.key || `promo-tile-${index}` })
        : tile;
    });
  };
  return <DisplayTiles />;
};

export const exportsForTesting = {
  RegisteredTender,
  PreferredPricingPromo,
  PlccAcquisitionPromo,
  AppAwarenessPromo,
  ProOnlineExperiencePromo,
  VolumePricingPromo,
  TextToConfirmPromo,
  ProXtraGeneralKnowledgePromo,
  PaintProductsPromo,
  ManageProjectMore,
  RenderPromotionTiles,
};

export { OffersPromotionSection as default };
